export default __webpack_public_path__ + "static/media/JHU_IncidentCases_Country.5361f643.csv";